import { CSSInterpolation } from '@emotion/serialize';
import { Color } from '../../theme/tokens';
import { Theme } from '../../theme/types';

const appearanceStyle: CSSInterpolation = {
  webkitAppearance: 'none',
  mozAppearance: 'none',
};
const searchStyle: CSSInterpolation = { display: 'none' };

export const inputReset: CSSInterpolation = {
  // Remove Safari and Chrome appearance
  // Remove Firefox appearance
  'input[type="url"]': appearanceStyle,
  'input[type="tel"]': appearanceStyle,
  'input[type="text"]': appearanceStyle,
  'input[type="date"]': appearanceStyle,
  'input[type="email"]': appearanceStyle,
  'input[type="number"]': appearanceStyle,
  'input[type="search"]': appearanceStyle,
  'input[type="password"]': appearanceStyle,
  // Remove arrows default styled in Firefox for input number
  // Remove arrows default styled in Safari and Chrome for input number
  "&[type='number']::-ms-clear": {
    appearance: 'textfield',
  },
  '&::-webkit-inner-spin-button': {
    webkitAppearance: 'none',
  },
  // Remove inner padding and search cancel button in Safari and Chrome on OS X
  // Safari (but not Chrome) clips the cancel button when the search input has padding (and "textfield" appearance)
  "&[type='search']::-ms-clear": searchStyle,
  "&[type='search']::-ms-reveal": searchStyle,
  "&[type='search']::-webkit-search-decoration": searchStyle,
  "&[type='search']::-webkit-search-cancel-button": searchStyle,
  "&[type='search']::-webkit-search-results-button": searchStyle,
  "&[type='search']::-webkit-search-results-decoration": searchStyle,
};

export enum FormFieldStatus {
  Success = 'Success',
  Error = 'Error',
}

export const statusStyle = (
  theme: Theme,
  { status, disabled }: { status?: FormFieldStatus; disabled?: boolean }
): {
  iconColor?: string;
  baseBorderColor?: string;
  focusBorderColor?: string;
  outlineColor?: string;
  textColor?: string;
  backgroundColor?: string;
  borderWidth?: string;
} => {
  const borderWidth = theme.tokens.borderScale * 1 + 'px'; // Having issues with BorderFns types here

  if (status === FormFieldStatus.Error) {
    return {
      borderWidth,
      iconColor: theme.color(Color.Error_900),
      baseBorderColor: theme.color(Color.Error_900),
      focusBorderColor: theme.color(Color.Error_900),
      outlineColor: theme.color(Color.Error_900),
      textColor: theme.color(Color.ColdGrey_800),
      backgroundColor: theme.color(Color.White),
    };
  }

  if (status === FormFieldStatus.Success) {
    return {
      borderWidth,
      iconColor: theme.color(Color.Success_800),
      baseBorderColor: theme.color(Color.Success_800),
      focusBorderColor: theme.color(Color.Success_800),
      outlineColor: theme.color(Color.Success_800),
      textColor: theme.color(Color.ColdGrey_800),
      backgroundColor: theme.color(Color.White),
    };
  }

  if (disabled) {
    return {
      iconColor: theme.color(Color.ColdGrey_200),
      baseBorderColor: theme.color(Color.ColdGrey_200),
      focusBorderColor: theme.color(Color.ColdGrey_200),
      outlineColor: theme.color(Color.ColdGrey_200),
      textColor: theme.color(Color.ColdGrey_200),
      backgroundColor: theme.color(Color.White),
    };
  }

  return {
    iconColor: theme.color(Color.Secondary_800),
    baseBorderColor: theme.color(Color.ColdGrey_200),
    focusBorderColor: theme.color(Color.Secondary_400),
    outlineColor: theme.color(Color.Secondary_400),
    textColor: theme.color(Color.ColdGrey_800),
    backgroundColor: theme.color(Color.White),
  };
};
